export default __webpack_public_path__ + "static/media/cabinet1-after-2048w.b5b959d0.webp";